import { render, staticRenderFns } from "./TextSearchComp.vue?vue&type=template&id=b75c24fa&"
import script from "./TextSearchComp.vue?vue&type=script&lang=js&"
export * from "./TextSearchComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports